import styled from 'styled-components';

import alert from '~/assets/alert.svg';
import { StyledButton } from '~/components/Button/styles';
import {
  Content as ModalContent,
  Header,
  Title,
} from '~/components/Modal/styles';
import grid from '~/styles/grid';

export const Container = styled.div`
  ${ModalContent} {
    max-width: 450px;
  }

  ${Header} {
    text-align: center;
    &:after {
      display: none;
    }
  }

  ${Title} {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: ${grid.lg};
    margin-top: ${grid.sm};
  }

  ${StyledButton} {
    margin: ${grid.lg} ${grid.xs} ${grid.xs} ${grid.xs};
  }
`;

export const OptionList = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: ${grid.lg};
  margin-top: ${grid.md};
`;

export const Option = styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${grid.md};
  width: 100%;
`;

export const ErrorSpan = styled.span`
  color: #c11e1e;
  margin: 5px 0;

  :before {
    content: url(${alert});
    padding: 0 10px 0 0;
    vertical-align: -10%;
  }
`;
